import { render, staticRenderFns } from "./GroupSubscriptions.vue?vue&type=template&id=ddf5af90"
import script from "./GroupSubscriptions.vue?vue&type=script&lang=js"
export * from "./GroupSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports